var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuPack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09554 3.24985C9.34528 2.70097 9.89486 2.34827 10.5001 2.34827C11.1053 2.34827 11.6549 2.70097 11.9046 3.24985L13.4386 6.61828L17.1298 7.03012C17.7316 7.0976 18.238 7.50874 18.4245 8.08197C18.6116 8.6552 18.4446 9.28478 17.998 9.69105L15.255 12.185L16.0021 15.8081C16.1239 16.3987 15.8874 17.0053 15.3976 17.3594C14.9078 17.7142 14.2553 17.7504 13.7294 17.4526L10.5001 15.6251L7.2708 17.4526C6.74487 17.7504 6.09233 17.7142 5.60258 17.3594C5.11283 17.0053 4.87631 16.3987 4.99805 15.8081L5.7452 12.185L3.00217 9.69105C2.55556 9.28478 2.3886 8.6552 2.57573 8.08197C2.76217 7.50874 3.26862 7.0976 3.87037 7.03012L7.56159 6.61828L9.09554 3.24985Z",
    fill: props.fillSecondary
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuPack);
export default __webpack_public_path__ + "static/media/icon_menu_pack.9396182af1649451eb5ff6270a645144.svg";
export { ForwardRef as ReactComponent };